import { render } from "./NotificationItemComponent.vue?vue&type=template&id=10d5bb3a&scoped=true"
import script from "./NotificationItemComponent.vue?vue&type=script&lang=js"
export * from "./NotificationItemComponent.vue?vue&type=script&lang=js"

import "./NotificationItemComponent.vue?vue&type=style&index=0&id=10d5bb3a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10d5bb3a"]])

export default __exports__